import React from 'react';
import { useHistory } from 'react-router-dom';

function NotFound({statusCode,message}) {
  const history = useHistory();

  const handleGoBack = () => {
    history.push('/dashboard');
  };

  return (
    <div style={styles.container}>
      <h1 style={styles.heading}>{statusCode}  - {message}</h1>
      <p style={styles.message}>Oops! The page you're looking for doesn't exist.</p>
      <button onClick={handleGoBack} style={styles.button}>
        Go to Dashboard
      </button>
    </div>
  );
}

const styles = {
  container: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    height: '100vh',
    textAlign: 'center',
  },
  heading: {
    fontSize: '2rem',
    color: '#333',
  },
  message: {
    fontSize: '1.2rem',
    color: '#666',
    marginBottom: '20px',
  },
  button: {
    padding: '10px 20px',
    fontSize: '1rem',
    color: '#fff',
    backgroundColor: '#007bff',
    border: 'none',
    borderRadius: '5px',
    cursor: 'pointer',
  },
};

export default NotFound;